import { render, staticRenderFns } from "./DefaultContactForm.vue?vue&type=template&id=554871b9&"
import script from "./DefaultContactForm.vue?vue&type=script&lang=ts&"
export * from "./DefaultContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports